import ActiveChildren from './ActiveChildren.jsx';

export default {
  path: '/active',
  element: <ActiveChildren />,
  protected: true,
  permission: 'active.view',
  standalone: false,
  sidebar: { label: 'الأطفال داخل القاعة', icon: 'children', group: 'main', order: 30 }
};
